import { v2_useAuthorizedCustomer } from '@crocodille/common';
import Link from 'next/link';
import LoyaltyCounter from '../loyalty-counter/loyalty-counter';
import cn from 'classnames';
import * as routing from '@routing';

import styles from './loyalty-status.module.scss';

interface LoyaltyStatusProps {
  readonly isMobileVisible?: boolean;
}

const LoyaltyStatus: React.FC<React.PropsWithChildren<LoyaltyStatusProps>> = ({
  isMobileVisible = false,
}) => {
  const { data: customer } = v2_useAuthorizedCustomer();

  return (
    <Link
      className={cn(styles.container, { [styles.visible]: isMobileVisible })}
      href={{
        pathname: routing.ACCOUNT_LOYALTY_CLUB,
        query: { scrollToContent: 'true' },
      }}
    >
      <LoyaltyCounter
        baguetteCounter={customer?.loyaltyCard?.scores?.product?.score ?? 0}
        coffeeCounter={customer?.loyaltyCard?.scores?.drink?.score ?? 0}
        collapsible={!isMobileVisible}
      />
    </Link>
  );
};

export default LoyaltyStatus;
